import RichTextWithBlokRenderer from "../../components/richTextRenderer/richTextRenderer";
import SBEditable from "../../components/sbEditable/sbEditable";
import styles from "./richTextIndention.module.scss";

function RichTextIndention({ blok }) {
  let className = "";
  switch (Number(blok.indent_level)) {
    case 0:
      className = styles.indention0;
      break;
    case 1:
      className = styles.indention1;
      break;
    case 2:
      className = styles.indention2;
      break;
    case 3:
      className = styles.indention3;
      break;
    case 4:
      className = styles.indention4;
      break;
    case 5:
      className = styles.indention5;
      break;
    case 6:
      className = styles.indention6;
      break;
    default:
      className = styles.indention0;
  }
  return (
    <SBEditable
      blok={blok}
      key={blok._uid}
      withClass={`${styles.root} ${className}`}
    >
      <RichTextWithBlokRenderer document={blok.content} />
    </SBEditable>
  );
}

export default RichTextIndention;
